import { IconProps } from './icon-props';

export const User = {
  Default: ({ ...props }: IconProps) => (
    <svg
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.3334 12.5C11.3334 10.178 8.94304 8.3 6.00008 8.3C3.05712 8.3 0.666748 10.178 0.666748 12.5M6.00008 6.5C6.82342 6.5 7.61303 6.18393 8.19521 5.62132C8.7774 5.05871 9.10447 4.29565 9.10447 3.5C9.10447 2.70435 8.7774 1.94129 8.19521 1.37868C7.61303 0.816071 6.82342 0.5 6.00008 0.5C5.17675 0.5 4.38713 0.816071 3.80495 1.37868C3.22276 1.94129 2.8957 2.70435 2.8957 3.5C2.8957 4.29565 3.22276 5.05871 3.80495 5.62132C4.38713 6.18393 5.17675 6.5 6.00008 6.5Z"
        stroke="#35373A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Fallback: ({ ...props }: IconProps) => (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="32" height="32" rx="16" fill="#1AB889" />
      <path
        d="M21.3334 22C21.3334 19.678 18.943 17.8 16.0001 17.8C13.0571 17.8 10.6667 19.678 10.6667 22M16.0001 16C16.8234 16 17.613 15.6839 18.1952 15.1213C18.7774 14.5587 19.1045 13.7956 19.1045 13C19.1045 12.2044 18.7774 11.4413 18.1952 10.8787C17.613 10.3161 16.8234 10 16.0001 10C15.1767 10 14.3871 10.3161 13.8049 10.8787C13.2228 11.4413 12.8957 12.2044 12.8957 13C12.8957 13.7956 13.2228 14.5587 13.8049 15.1213C14.3871 15.6839 15.1767 16 16.0001 16Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Edit: ({ ...props }: IconProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      {...props}
    >
      <g
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        clipPath="url(#clip0_39031_89942)"
      >
        <path d="M12.667 14v-1.333A2.667 2.667 0 0 0 10.001 10H6a2.667 2.667 0 0 0-2.667 2.667V14M8 7.333A2.667 2.667 0 1 0 8 2a2.667 2.667 0 0 0 0 5.333"></path>
      </g>
      <defs>
        <clipPath id="clip0_39031_89942">
          <path fill="currentColor" d="M0 0h16v16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  ),
};
